<template>
  <ul 
    v-if="list.length"
    v-rellax="{ list, rellaxSpeed }"
    class="posts-list">
    <li 
      :class="{'posts-list__single-post--effect': $_postHasFilterEffect(post.fields.category)}"
      v-for="(post, index) of list"
      :key="index"
      class="posts-list__single-post">
      <router-link :to="{ name: `${lang}.single-post`, params: { slug: post.fields.slug } }">
        <div class="swiper-slide__img-container">
          <img
            v-if="typeof post.fields.image !== 'undefined'"
            v-lazy="post.fields.image.fields.file.url"
            v-lazy:background-image="lazyLoading"
            :key="post.fields.image.fields.file.url"
            :alt="post.fields.image.fields.description"
            :width="post.fields.image.fields.file.details.image.width"
            :height="post.fields.image.fields.file.details.image.height">
          <div 
            v-if="$_postHasFilterEffect(post.fields.category)"
            class="posts-list__single-post--effect__after"></div>  
        </div>
        <h5>{{ post.fields.title }}</h5>
        <span>{{ $t('common.discover') }}</span>
      </router-link>
    </li>
  </ul>
</template>

<script>
import Rellax from 'rellax'
import { mapGetters } from 'vuex'
export default {
  name: 'PostsList',
  data: () => ({
    rellaxRef: undefined,
    lazyLoading: require('@/assets/lazy/post.png')
  }),
  props: {
    list: {
      type: Array,
      required: true
    },
    rellaxSpeed: {
      type: Number,
      default: undefined
    }
  },
  computed: {
    ...mapGetters([
      'lang'
    ]),
  },
  methods: {
    $_postHasFilterEffect(category) {
      if (category === 'Live from') return false
      return true
    },
  },
  directives: {
    'rellax': {
      inserted (el, binding, vnode) {
        if (typeof binding.value.rellaxSpeed !== 'undefined'){
          const rellaxRef = new Rellax(el, {
            speed: binding.value.rellaxSpeed,
            center: false,
            wrapper: null,
            round: true,
            vertical: true,
            horizontal: false
          })
          vnode.context.$data.rellax = rellaxRef
        }
      },
      componentUpdated(el, binding, vnode){
        if (typeof binding.value.rellaxSpeed !== 'undefined') vnode.context.$data.rellax.refresh()
      },
      unbind (el, binding, vnode) {
        if (typeof binding.value.rellaxSpeed !== 'undefined') vnode.context.$data.rellax.destroy()
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./list.scss";
</style>
